import helperFunctions from '../classes/HelperFunctions';
import dateFunctions from '../classes/DateFunctions';
import apiFunctions from '../classes/ApiServiceFunctions';
import candidateFunctions from '../classes/CandidateFunctions';

const methods = Object.assign({}, helperFunctions, dateFunctions, apiFunctions, candidateFunctions);

export default methods;